import { Typography } from "@mui/material"
import { Box } from "@mui/system"
import { Loader } from "components/Loader"
import { ConnexionError } from "components/ConnexionError.tsx"
import { useCardHolderContext } from "layouts/card-holder/context/useCardHolderContext.ts"

const CenteredMessage = ({ children }: { children: React.ReactNode }) => (
    <Box sx={{ display: "flex", justifyContent: "center" }}>{children}</Box>
)

export const VehicleListWrapper = ({
     children
}: {
    children: React.ReactNode
}) => {
    const { apiSuccess, isLoading, noResultFilter } = useCardHolderContext()

    if (isLoading && apiSuccess == null)
        return (
            <CenteredMessage>
                <Loader />
            </CenteredMessage>
        )
    if (!apiSuccess)
        return (
            <CenteredMessage>
                <ConnexionError />
            </CenteredMessage>
        )
    if (noResultFilter)
        return (
            <CenteredMessage>
                <Typography sx={{ color: "grey.600" }}>
                    Aucun résultat
                </Typography>
            </CenteredMessage>
        )

    return <>{children}</>
}